import messages from "./messages.json";
import { Access, Message } from "../../../../../context";

const MESSAGES = (messages as unknown) as Record<string, string>;

type State = {
  accesses: Access[];
  create: boolean;
  message: Message;
};

type Action =
  | {
      type: "add-access";
      access: Access;
    }
  | {
      type: "remove-access";
      access: Access;
    }
  | {
      type: "set-message";
      message: Message;
    }
  | {
      type: "reset";
      accesses: Access[] | undefined;
    };

export function init(accesses: Access[] = []): State {
  return {
    accesses: accesses,
    create: !accesses.length,
    message: {
      content: accesses.length
        ? MESSAGES.access_added.replace("[[COUNT]]", `${accesses.length}`)
        : MESSAGES.root,
    },
  };
}

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case "add-access":
      return action.access.environment
        ? state.accesses.find(
            ({ environment, role }) =>
              environment === action.access.environment &&
              role === action.access.role
          )
          ? {
              ...state,
              message: {
                content: MESSAGES.duplicated_access_error,
                error: true,
              },
            }
          : {
              ...state,
              accesses: state.accesses.concat(action.access),
              message: {
                content: MESSAGES.access_added.replace(
                  "[[COUNT]]",
                  `${state.accesses.length + 1}`
                ),
              },
            }
        : state.accesses.find(({ role }) => role.id === action.access.role.id)
        ? {
            ...state,
            message: {
              content: MESSAGES.duplicated_access_error,
              error: true,
            },
          }
        : {
            ...state,
            accesses: state.accesses.concat(action.access),
            message: {
              content: MESSAGES.access_added.replace(
                "[[COUNT]]",
                `${state.accesses.length + 1}`
              ),
            },
          };
    case "remove-access":
      return {
        ...state,
        accesses: state.accesses.filter((access) => access !== action.access),
        message: {
          content:
            state.accesses.length > 1
              ? MESSAGES.access_added.replace(
                  "[[COUNT]]",
                  `${state.accesses.length - 1}`
                )
              : MESSAGES.root,
        },
      };
    case "set-message":
      return {
        ...state,
        message: action.message,
      };
    case "reset":
      return init(action.accesses);
    default:
      return state;
  }
}
